import { render, staticRenderFns } from "./updatePaymentPaypal.vue?vue&type=template&id=39bfffd2&scoped=true&"
import script from "./updatePaymentPaypal.vue?vue&type=script&lang=js&"
export * from "./updatePaymentPaypal.vue?vue&type=script&lang=js&"
import style0 from "./updatePaymentPaypal.vue?vue&type=style&index=0&id=39bfffd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bfffd2",
  null
  
)

export default component.exports